"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACOtpElement = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var react_1 = require("react");
var ACOtpElement = function (props) {
    var length = props.length;
    var _a = (0, react_1.useState)(Array(length).fill('')), otp = _a[0], setOtp = _a[1];
    var inputRefs = (0, react_1.useRef)([]);
    var handleChange = function (e, index) {
        var _a;
        var value = e.target.value;
        if (/^[0-9]$/.test(value) || value === '') {
            var newOtp = __spreadArray([], otp, true);
            newOtp[index] = value;
            setOtp(newOtp);
            props.onChange && props.onChange(newOtp.join(''));
            // Move to next input if not the last one
            if (value && index < length - 1) {
                (_a = inputRefs.current[index + 1]) === null || _a === void 0 ? void 0 : _a.focus();
            }
        }
    };
    var handleKeyDown = function (e, index) {
        var _a;
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            (_a = inputRefs.current[index - 1]) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    var handlePaste = function (e) {
        e.preventDefault();
        var pasteData = e.clipboardData.getData('text');
        if (/^\d+$/.test(pasteData)) {
            var newOtp = pasteData.split('').slice(0, length);
            setOtp(newOtp.concat(Array(length - newOtp.length).fill('')));
            props.onChange && props.onChange(newOtp.join(''));
            newOtp.forEach(function (_, idx) {
                var _a;
                if (inputRefs.current[idx]) {
                    (_a = inputRefs.current[idx]) === null || _a === void 0 ? void 0 : _a.focus();
                }
            });
        }
    };
    (0, react_1.useEffect)(function () {
        var _a;
        (_a = inputRefs.current[0]) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", { className: props.containerClassName, children: [Array.from({ length: length }).map(function (_, index) { return ((0, jsx_runtime_1.jsx)(antd_1.Input, { disabled: props.disabled, className: props.className, maxLength: 1, status: props.required && props.errorText ? 'error' : '', value: otp[index], onChange: function (e) { return handleChange(e, index); }, onKeyDown: function (e) { return handleKeyDown(e, index); }, onPaste: handlePaste, ref: function (el) { return (inputRefs.current[index] = el); }, type: "tel", inputMode: "numeric", pattern: "[0-9]*", style: props.style || {} }, index)); }), props.required ? ((0, jsx_runtime_1.jsx)("p", { className: props.errorClassName, children: props.errorText && props.errorText })) : ('')] }));
};
exports.ACOtpElement = ACOtpElement;
